import JSZip from 'jszip';

const isDocxFile = (file) => {
  if (!file) return false;
  const name = String(file.name || '').toLowerCase();
  const type = String(file.type || '').toLowerCase();
  if (name.endsWith('.docx')) return true;
  return type.includes('officedocument.wordprocessingml')
    || type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
};

const isLegacyDocFile = (file) => {
  if (!file) return false;
  const name = String(file.name || '').toLowerCase();
  const type = String(file.type || '').toLowerCase();
  if (name.endsWith('.doc') && !name.endsWith('.docx')) return true;
  return type === 'application/msword';
};

const xmlLocalName = (node) => {
  if (!node) return '';
  if (node.localName) return String(node.localName);
  const raw = String(node.nodeName || '');
  const parts = raw.split(':');
  return parts[parts.length - 1] || '';
};

const collectDocxPlainText = (xmlText) => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(xmlText, 'application/xml');
  if (doc.querySelector('parsererror')) {
    throw new Error('Invalid Word XML');
  }

  const lines = [];
  const walk = (node, intoParagraph) => {
    if (!node) return;
    const name = xmlLocalName(node);
    if (node.nodeType === Node.TEXT_NODE) {
      if (intoParagraph) intoParagraph.push(String(node.nodeValue || ''));
      return;
    }
    if (node.nodeType !== Node.ELEMENT_NODE) return;

    if (name === 'p') {
      const parts = [];
      Array.from(node.childNodes || []).forEach((child) => walk(child, parts));
      const line = parts.join('').replace(/\u00a0/g, ' ').replace(/[ \t]+\n/g, '\n').trimEnd();
      lines.push(line);
      return;
    }

    if (name === 'br' || name === 'cr') {
      if (intoParagraph) intoParagraph.push('\n');
      return;
    }

    if (name === 'tab') {
      if (intoParagraph) intoParagraph.push('\t');
      return;
    }

    Array.from(node.childNodes || []).forEach((child) => walk(child, intoParagraph));
  };

  walk(doc.documentElement, null);
  return lines
    .join('\n')
    .replace(/\n{3,}/g, '\n\n')
    .trim();
};

/**
 * Extract plain text from a .docx File / Blob.
 * Legacy .doc is not supported in the browser.
 */
export const extractPlainTextFromWordFile = async (file) => {
  if (!file) throw new Error('No file');
  if (isLegacyDocFile(file)) {
    const error = new Error('LEGACY_DOC');
    error.code = 'LEGACY_DOC';
    throw error;
  }
  if (!isDocxFile(file)) {
    const error = new Error('NOT_DOCX');
    error.code = 'NOT_DOCX';
    throw error;
  }

  const buffer = await file.arrayBuffer();
  const zip = await JSZip.loadAsync(buffer);
  const documentFile = zip.file('word/document.xml');
  if (!documentFile) {
    const error = new Error('NOT_DOCX');
    error.code = 'NOT_DOCX';
    throw error;
  }
  const xml = await documentFile.async('string');
  const text = collectDocxPlainText(xml);
  return text;
};
